const ENTITY_DETAIL_TEMPLATE = {
  displayMode: {
    name: {
      editType: "text",
      label: "Name",
      modelKey: "name",
      display: false,
    },

    entityId: {
      displayStyle: "text",
      label: "Entity ID",
      modelKey: "pk",
      display: true,
    },

    entityType: {
      displayStyle: "chip",
      editType: "single-select-dropdown",
      label: "Entity Type",
      availableInModel: true,
      modelKey: "entityTypeLabel",
      emptyDisplay: "-",
      display: true,
    },

    parentEntity: {
      editType: "single-select-dropdown",
      displayStyle: "text",
      label: "Parent Entity",
      availableInModel: true,
      urlPath: "core/dynamic-options/entities/",
      queryParams: {},
      setQueryParams: (value) => ({ search: value }),
      availableInModel: false,
      modelKey: "parent.name",
      modelValueKey: "key",
      modelValueLabel: "name",
      modelValueKeyType: Number,
      display: true,
    },

    address: {
      displayStyle: "text",
      label: "Address",
      modelKey: "address.raw",
      display: true,
    },

    homepageUrl: {
      displayStyle: "text",
      label: "Homepage URL",
      modelKey: "website",
      display: true,
    },

    phone: {
      displayStyle: "text",
      label: "Phone",
      modelKey: "phone",
      display: true,
    },

    email: {
      displayStyle: "text",
      label: "Email",
      modelKey: "email",
      display: true,
    },
  },
  editMode: [
    [
      {
        name: "name",
        type: "text",
        label: "Name",
        modelKey: "name",
        width: 60,
      },
      {
        name: "website",
        type: "text",
        label: "Homepage URL",
        modelKey: "website",
        width: "40",
      },
    ],
    [
      {
        name: "entityType",
        type: "single-select-dropdown",
        displayStyle: "text",
        label: "Entity Type",
        modelKey: "entityType",
        width: 50,
        needsInitialValueFetch: true,
        isURLBased: true,
        url: "core/dynamic-options/entity_types",
        queryParams: {},
        modelValueKey: "key",
        modelValueLabel: "label",
        modelValueKeyType: Number,
        fetchStaticLabel: false,
        formatValue: (value) => {
          if (value === undefined || value === null || value === "") {
            return null;
          }

          if (typeof value === "object") {
            return {
              id: value?.id ?? value?.key,
              label: value?.label ?? "",
            };
          }

          return { id: value, label: "" };
        },
        dataFormatter: (data) => data?.map((item) => ({ id: item.key, label: item.label })) ?? [],
      },
      {
        name: "parent",
        type: "single-select-dropdown",
        displayStyle: "text",
        label: "Parent Entity",
        availableInModel: false,
        isURLBased: true,
        url: "core/dynamic-options/entities",
        queryParams: {},
        width: 50,
        needsInitialValueFetch: false,
        fetchStaticLabel: false,
        formatValue: (value) => {
          if (value === undefined || value === null || value === "") {
            return null;
          }

          if (typeof value === "object") {
            return { id: value?.id ?? value?.key, label: value?.name ?? value?.value ?? "" };
          }

          return { id: value, label: "" };
        },
        dataFormatter: (data) => data?.map((item) => ({ id: item.key, label: item.value })) ?? [],
        modelKey: "parent",
      },
    ],
    [
      {
        name: "address",
        type: "address",
        label: "Address",
        modelKey: "address",
        type: "address",
        width: "100",
      },
    ],
    [
      {
        name: "email",
        type: "text",
        label: "Email",
        modelKey: "email",
        width: "50",
      },
      {
        name: "phone",
        type: "text",
        label: "Phone",
        modelKey: "phone",
        width: "50",
      },
    ],
  ],
};

export default ENTITY_DETAIL_TEMPLATE;
